import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Toast, ToastContainer } from "react-bootstrap";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import {
  ScrollToTop,
} from "./components";
import { rulesViewNavbar } from "./config/rules-navbar.config";
import { AuthPage, DashboardPage, EngagementListPage, HomePage, MorePartsPage, ProductCreate, ProductListPage, ProductPage, ProductUpdate } from "./modules";
import { NavbarHeader, NavbarTop, NavbarFooter } from "./ds";
import { ContactPage, CoreStrings, FAQPage } from "./core";
import { SearchApiImpl, SearchPage } from "./modules/search";
import { SubscriptionPage, SubscriptionStatementPage } from "./modules/subscription";
import { PaymentPage, PaymentOrdersPage, PaymentAdsPage } from "./modules/payment/site/impl";
import { DeleteAccountPage, RecoveryAccessPage, SignupPage } from "./modules/account/site/impl";
import { useState, useEffect } from "react";
import { AdsSubscriptionPage, AdsStatementPage } from "./modules/ads";
import { AdsCreatePage, AdsListPage, AdsUpdatePage } from "./modules/ads/site/impl/screens";
import { AboutPage } from "./core";
import { SubscriptionsReportPage } from "./modules/reports";

function App() {
  const [storagedToast, setStoragedToast] = useState(
    localStorage.getItem('global-toast')
      ? JSON.parse(localStorage.getItem('global-toast'))
      : []
  );
  const translate = CoreStrings['PTBR'];
  const navigate = useNavigate();
  const location = useLocation();

  const {
    isShowNavTop,
    isShowNavHeader,
    isShowNavFooter,
    haveExceptionalHeader,
    ExceptionalHeader,
    isFluid,
  } = rulesViewNavbar(location.pathname.toLowerCase());

  useEffect(() => {

    if (storagedToast.message) {
      localStorage.removeItem('global-toast');
    }
  }, [storagedToast]);

  const hideToast = () => setStoragedToast([]);
  const theme = { navbar: 'bg-white', top: 'bg-white' }
  return (
    <div className="App" style={{ backgroundColor: "#f7fbfc" }}>
      {isShowNavTop && <NavbarTop translate={translate.core.navbarTop} themeColor={theme.top} />}
      {isShowNavHeader && <NavbarHeader navigate={navigate} themeColor={theme.navbar} SearchInput={new SearchApiImpl()} />}
      {haveExceptionalHeader && ExceptionalHeader}
      <Container fluid={isFluid} className={isShowNavHeader ? "mt-5" : ""}>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/account/delete-account" element={<DeleteAccountPage />} />
            <Route path="/adm/ads-create" element={<AdsCreatePage navigate={navigate} />} />
            <Route path="/adm/ads-list" element={<AdsListPage />} />
            <Route path="/adm/ads-statement" element={<AdsStatementPage />} />
            <Route path="/adm/ads-update" element={<AdsUpdatePage />} />
            <Route path="/adm/dashboard" element={<DashboardPage />} />
            <Route path="/adm/engagement" element={<EngagementListPage />} />
            <Route path="/adm/paymentOrder" element={<PaymentOrdersPage navigate={navigate} />} />
            <Route path="/adm/productCreate" element={<ProductCreate navigate={navigate} />} />
            <Route path="/adm/productList" element={<ProductListPage />} />
            <Route path="/adm/productUpdate" element={<ProductUpdate navigate={navigate} />} />
            <Route path="/adm/report/subscriptions" element={<SubscriptionsReportPage navigate={navigate} />} />
            <Route path="/adm/subscription/statement" element={<SubscriptionStatementPage navigate={navigate} />} />
            <Route path="/ads/payment" element={<PaymentAdsPage navigate={navigate} />} />
            <Route path="/ads/subscribe" element={<AdsSubscriptionPage />} />
            <Route path="/auth/*" element={<AuthPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/more_parts" element={<MorePartsPage />} />
            <Route path="/payment/*" element={<PaymentPage navigate={navigate} />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/recovery-access" element={<RecoveryAccessPage />} />
            <Route path="/search/*" element={<SearchPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/subscription" element={<SubscriptionPage />} />
          </Routes>
        </ScrollToTop>
      </Container>
      {isShowNavFooter && <NavbarFooter translate={translate.core.navbarFooter} />}
      {storagedToast.message && (
        <ToastContainer className="p-3" position="top-end" style={{ zIndex: 1 }}>
          <Toast onClose={hideToast} show={storagedToast.message !== ''} delay={7000} bg={storagedToast.type} autohide>
            <Toast.Header>
              <strong className="me-auto">Montacar</strong>
            </Toast.Header>
            <Toast.Body className="text-white">{storagedToast.message}</Toast.Body>
          </Toast>
        </ToastContainer>
      )}
    </div>
  );
}

export default App;
